import { render, staticRenderFns } from "./Amounts.vue?vue&type=template&id=d8388428"
import script from "./Amounts.vue?vue&type=script&lang=js"
export * from "./Amounts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports